import { FieldExtensionComponentProps } from "@backstage/plugin-scaffolder-react";
import { Defineable } from "@internal/backstage-plugin-utility-common";

import { useOktaToken } from "../hook/useOktaToken";
import styles from "./OktaToken.module.css";

/**
 * Scaffolder field extension that silently acquires an Okta access token and
 * stores it in template secrets.
 *
 * Reads `secretsKey` from `uiSchema["ui:options"]`. Renders a loading state
 * while authenticating, an error message on failure, nothing when `formData`
 * is absent, and a success indicator when the token is set.
 *
 * @param props - Standard scaffolder field extension component props.
 */
export const OktaToken = ({
    onChange,
    formData,
    uiSchema,
}: FieldExtensionComponentProps<string>) => {
    const secretsKey = uiSchema?.["ui:options"]
        ?.secretsKey as Defineable<string>;

    const { loading, error } = useOktaToken({ secretsKey, onChange });

    if (loading) {
        return <div>Authenticating...</div>;
    }

    if (error) {
        return <div className={styles.error}>Error: {error}</div>;
    }

    if (!formData) {
        return null;
    }

    return <div className={styles.success}>Okta Authentication Ready</div>;
};
